import { ProfileYourAwardsCardSkeleton } from './profile-your-awards-card-skeleton'
import React from 'react'
import { Grid } from 'src/component/ui/grid/grid'

export const ProfileCompletedChallengesSkeleton = (): React.ReactElement => {
  return (
    <Grid.Skeleton columns={6} count={6}>
      <ProfileYourAwardsCardSkeleton />
    </Grid.Skeleton>
  )
}
